import { render, staticRenderFns } from "./TransportDocument.vue?vue&type=template&id=54d9818b"
import script from "./TransportDocument.vue?vue&type=script&lang=ts"
export * from "./TransportDocument.vue?vue&type=script&lang=ts"
import style0 from "./TransportDocument.vue?vue&type=style&index=0&id=54d9818b&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports